import ApiClient from './ApiClient';

class RoleApi extends ApiClient {
  constructor() {
    super('roles', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new RoleApi();
